import React, { useEffect, useState } from 'react';
import './skip-waba-setup-screen.scss';
import { SVGS } from '../../../assets';
import {
  getWorkspaceId,
  useAppSelector,
  useLazyGenerateEmbeddedSignupLinkQuery,
} from '@zonofi/seller-rtk-store';
import { getConfigValue } from '@zonofi/common/functions/get-config-value/get-config-value';

export const SkipWABASetupScreen: React.FC = () => {
  const workspaceId = useAppSelector(getWorkspaceId);
  const [copied, setCopied] = useState(false);

  const [generateEmbeddedSignupLink, generateEmbeddedSignupLinkResponse] =
    useLazyGenerateEmbeddedSignupLinkQuery();

  const link = generateEmbeddedSignupLinkResponse?.data?.esLink;

  useEffect(() => {
    generateEmbeddedSignupLink({
      sellerWorkspaceId: workspaceId,
    });
  }, []);
  // Function to handle copy functionality
  const handleCopy = async (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();

    try {
      await navigator.clipboard.writeText(getConfigValue('APP_ENDPOINT'));
      // Show copied notification
      setCopied(true);
      // Reset after 3 seconds
      setTimeout(() => {
        setCopied(false);
      }, 3000);
    } catch (error) {
      console.error('Error copying text:', error);
      alert('Failed to copy link. Please try manually copying it.');
    }
  };

  // Function to handle share functionality
  const handleShare = async (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();

    if (navigator.share) {
      try {
        await navigator.share({
          title: 'WABA Setup Link',
          text: 'Please open this link on a desktop browser to continue with WABA setup',
          url: getConfigValue('APP_ENDPOINT'),
        });
      } catch (error) {
        console.error('Error sharing:', error);
      }
    } else {
      // Fallback for browsers that don't support Web Share API
      alert(
        'Share functionality is not supported in this browser. You can copy the link manually.'
      );
    }
  };

  return (
    <div className="skip-waba-setup">
      <div className="skip-waba-setup-container">
        <div className="skip-waba-setup-container-zotok-logo">
          <img src={SVGS.ZotokLogo} alt="" width={100} />
        </div>
        <div className="skip-waba-setup-container-image">
          <img src={SVGS.RegistredImage} alt="" width={160} />
        </div>
        <div className="skip-waba-setup-container-text-container">
          <span className="primary-font-semibold skip-waba-setup-container-text-container-greeting-header">
            Thank You!
          </span>
          <span className="primary-font-regular skip-waba-setup-container-text-container-greeting-text">
            You have successfully registered as a seller.{' '}
          </span>
          <span className="primary-font-semibold skip-waba-setup-container-text-container-header">
            ZöTok App is not accessible in the mobile browser.
          </span>
          <span className="primary-font-regular skip-waba-setup-container-text-container-description">
            Please use the below link to login to ZöTok App in the desktop
            chrome browser.
          </span>
          <div className="skip-waba-setup-container-text-container-copy-short-link">
            <div
              className="skip-waba-setup-container-text-container-copy-short-link-container"
              onClick={() => {}}
            >
              <div className="primary-font-regular skip-waba-setup-container-text-container-copy-short-link-container-link">
                <a
                  href={process.env.NX_APP_ENDPOINT}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => {}}
                >
                  {process.env.NX_APP_ENDPOINT}
                </a>
              </div>
              <div className="skip-waba-setup-container-text-container-copy-short-link-container-icons">
                <div className="skip-waba-setup-container-text-container-copy-short-link-container-icons-container">
                  <img
                    src={SVGS.CopyIcon}
                    alt=""
                    width={20}
                    height={20}
                    className="skip-waba-setup-container-text-container-copy-short-link-container-icons-container-icon"
                    onClick={handleCopy}
                  />
                </div>
                <div className="skip-waba-setup-container-text-container-copy-short-link-container-icons-container">
                  <img
                    src={SVGS.ShareIcon}
                    alt=""
                    width={20}
                    height={20}
                    className="skip-waba-setup-container-text-container-copy-short-link-container-icons-container-icon"
                    onClick={handleShare}
                  />
                </div>
              </div>
            </div>
            {copied && (
              <div
                className="skip-waba-setup-container-copy-short-link-notification-space primary-font-regular"
                style={{
                  height: '24px',
                  marginTop: '8px',
                  fontSize: '14px',
                }}
              >
                <div className="skip-waba-setup-container-copy-short-link-notification-space-text">
                  Link copied to clipboard!
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
